import React from 'react'
import Question_ from "../assets/Question.png";
import multi_choices from "../assets/multi_choices.jpg";
import { useState, useEffect } from 'react';
import axios from 'axios';
import { QuestionTypes } from '../constants';
import { useParams } from 'react-router-dom';
import { BASE_URL } from "../constants";


export default function OpenEndedAnswerAnalysis({ question }) {
    const { id } = useParams();
    const [answers, setAnswers] = useState({participation:0 , answers:[]});
    useEffect(() => {
        const fetchAswer = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/lesson/questionAllAnswers.php?questionId=${question.id}&lessonId=${id}`);
                setAnswers(response.data);
            } catch (err) {
                console.log("error: ", err);
            }
        }
        fetchAswer();
        const interval = setInterval(fetchAswer, 5000);
        return () => {
            clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [question.id])


    return (
        <div className="question-overlay">
            <div className="flex items-center font-semibold text-lg gap-2">
                <img src={question.type == QuestionTypes.multiChoices ? multi_choices : Question_} alt="Icon" />
                <p className='m-0'> {question.type == QuestionTypes.multiChoices ? `Multi Choices Question (${answers.total})` : `Open Ended Question (${answers.total})`}   </p>
            </div>

            <div className="flex flex-col gap-4">
                <div className='flex justify-between items-center'>
                    <h1 className='m-0'>{question.questionBody}</h1>
                    <p className='m-0 text-lg font-semibold'>Participation: {(answers.participation || 0).toFixed(1)} %</p>
                </div>
                <div className='font-semibold text-lg w-3/4 mx-auto flex flex-col gap-1'>
                    <div className="grid grid-cols-3">
                        <div className="flex justify-center">No. </div>
                        <div className="flex justify-center">Student</div>
                        <div className="flex justify-center">Answer</div>
                    </div>
                    <div className='border-b-lightAqua border-b' />
                    {
                        Object.values(answers.answers).map((data, idx) =>
                            <div className='flex flex-col gap-1' key={idx}>
                                <div className="grid grid-cols-3">
                                    <div className="flex justify-center"> {idx + 1}</div>
                                    <div className="flex justify-center"> {data.fullname}</div>
                                    <div className="flex justify-center">{data.answer}</div>
                                </div>
                                <div className='border-b-lightAqua border-b' />
                            </div>
                        )
                    }
                </div>
            </div>

            <div />
        </div>
    )
}
